import { format } from 'date-fns';
import { getCalendarEventDateString } from '.';

import type { CalendarEvent, LocaleMessages } from 'shared-types';

interface Params {
  calendarEvent: {
    description?: CalendarEvent['description'];
    endDate: Date;
    lastJoinDate?: Date;
    link?: CalendarEvent['link'];
    linkText?: CalendarEvent['linkText'];
    location?: CalendarEvent['location'];
    message?: CalendarEvent['message'];
    startDate: Date;
    title: CalendarEvent['title'];
  };
  messages: LocaleMessages;
  timeZone: string;
  userAttributes?: { title: string; value: string }[];
}

const getCalendarEventDetailsEmailContent = ({
  calendarEvent,
  messages,
  timeZone,
  userAttributes
}: Params) => {
  let eventDetails = '';

  eventDetails += `<strong>${messages.commonTitle}</strong>: ${calendarEvent.title}`;
  eventDetails += `<br><strong>${
    messages.commonTime
  }</strong>: ${getCalendarEventDateString({
    startDate: new Date(calendarEvent.startDate),
    endDate: calendarEvent.endDate
      ? new Date(calendarEvent.endDate)
      : undefined,
    timeZone
  })}`;

  if (calendarEvent.lastJoinDate) {
    eventDetails += `<br><strong>${
      messages.eventCalendarJoinLastDate
    }</strong>: ${format(
      new Date(calendarEvent.lastJoinDate),
      'dd.MM.yyyy HH:mm'
    )}`;
  }

  if (calendarEvent.link) {
    eventDetails += `<br><strong>${messages.commonLink}</strong>: <a href=${
      calendarEvent.link
    }>${calendarEvent.linkText || calendarEvent.link}</a>`;
  }

  if (calendarEvent.location) {
    eventDetails += `<br><strong>${messages.commonLocation}</strong>: ${calendarEvent.location}`;
  }

  if (calendarEvent.description) {
    eventDetails += `<br><br><strong>${messages.commonDescription}</strong>: ${calendarEvent.description}`;
  }

  if (calendarEvent.message) {
    eventDetails += `<br><strong>${messages.eventCalendarParticipantInfo}</strong>: <p>${calendarEvent.message}</p>`;
  }

  if (userAttributes?.length) {
    userAttributes.forEach((attribute) => {
      eventDetails += `<br><strong>${attribute.title}</strong>: ${attribute.value}`;
    });
  }

  return eventDetails;
};

export default getCalendarEventDetailsEmailContent;
